// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapseSection_container__3w2LM"};